import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { setSentryCapture } from "@workspace/api-client-react";
import App from "./App";
import "./i18n";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  environment: import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  beforeSend(event) {
    if (event.request) {
      event.request.data = undefined;
      event.request.cookies = {};
      if (event.request.headers) {
        const { authorization, cookie, ...safe } = event.request.headers as Record<string, string>;
        void authorization; void cookie;
        event.request.headers = safe;
      }
    }
    event.extra = undefined;
    const redact = (s: string) =>
      s
        .replace(/[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}/g, "[EMAIL]")
        .replace(/\b(?:cus|pi|cs|sub|ch|tr|in|pm)_[A-Za-z0-9]+/g, "[STRIPE_ID]")
        .replace(/\$\s*[\d,]+(?:\.\d{1,2})?/g, "[AMOUNT]")
        .replace(/\b\d{1,3}(?:,\d{3})+(?:\.\d{1,2})?\b/g, "[AMOUNT]");
    if (event.message) event.message = redact(event.message);
    if (event.exception?.values) {
      event.exception.values = event.exception.values.map((v) => ({
        ...v,
        value: v.value ? redact(v.value) : v.value,
      }));
    }
    event.breadcrumbs = undefined;
    return event;
  },
});

setSentryCapture((err, context) =>
  Sentry.captureException(err, context as Parameters<typeof Sentry.captureException>[1]),
);

createRoot(document.getElementById("root")!).render(<App />);
